export function makeNumIntoDigits(num: number, digit: number = 8): string {
  return num.toString().padStart(digit, "0");
}
